export default function UnselectCollection(state, payload){
  const {collection} = payload;
  delete state.selectedCollections[collection.id]
  return {...state}
}